import { emptyObject } from '@constants/empty';
import { useRouter } from 'next/router';
import { getLeaderboardKey } from '@cont/Compete/utils';
import keepPreviousResult from '@api/hooks/middleware/keepPreviousResult';
import useInfiniteFetch from '@hooks/useInfiniteFetch';
import { useEffect, useRef } from 'react';

const useLeaderboardWithPagination = (
  examFilter,
  stateFilter,
  options = {
    revalidateOnMount: false,
    fallbackData: undefined
  }
) => {
  const { query } = useRouter();

  const key = getLeaderboardKey(
    query.goalUID,
    10,
    examFilter,
    stateFilter,
    false
  );

  const ref = useRef(null);

  useEffect(() => {
    ref.current = true;
  }, []);

  const { data, ...rest } = useInfiniteFetch(
    key,
    {
      applyOffsetsAutomatically: true,
      hasQueryParams: true
    },
    {
      fallbackData: !ref.current ? [options.fallbackData] : undefined,
      revalidateOnMount: true,
      revalidateFirstPage: false,
      use: [keepPreviousResult]
    }
  );

  return {
    data: data?.leaderboardData ?? emptyObject,
    myData: data?.myRank,
    ...rest
  };
};

export default useLeaderboardWithPagination;
